export const Main_Header = 'Enter or copy/paste Tax IDs';
export const Sub_Header = 'Tax IDs must contain 9 digits (include leading 0s) and must be separated by a space.';
export const MAX_TIN_LIMIT = 1000;